import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "orpheus.mask.state"
const MASK_CHAR = "*"
const MASKED_CLASS = "orpheus-masked"

export default class extends Controller {
  static targets = ["item", "label", "icon"]
  static values = { scope: { type: String, default: "default" } }

  connect() {
    this.applyState(this.currentState)
  }

  itemTargetConnected(el) {
    this.applyToItem(el, this.currentState)
  }

  toggleAll(event) {
    if (event) event.preventDefault()
    const next = this.currentState === "masked" ? "unmasked" : "masked"
    sessionStorage.setItem(this.storageKey, next)
    this.applyState(next)
  }

  toggleItem(event) {
    event.stopPropagation()
    const el = event.currentTarget
    const isMasked = el.classList.contains(MASKED_CLASS)
    this.applyToItem(el, isMasked ? "unmasked" : "masked")
  }

  applyState(state) {
    this.itemTargets.forEach((el) => this.applyToItem(el, state))
    this.labelTargets.forEach((el) => {
      el.textContent = state === "masked" ? "Unmask all" : "Mask all"
    })
    this.iconTargets.forEach((el) => {
      el.dataset.maskState = state
    })
  }

  applyToItem(el, state) {
    if (el.dataset.maskOriginal === undefined) {
      el.dataset.maskOriginal = el.textContent
    }
    const original = el.dataset.maskOriginal
    if (state === "masked") {
      el.textContent = MASK_CHAR.repeat(original.length)
      el.classList.add(MASKED_CLASS)
    } else {
      el.textContent = original
      el.classList.remove(MASKED_CLASS)
    }
  }

  get storageKey() {
    return `${STORAGE_KEY}.${this.scopeValue}`
  }

  get currentState() {
    return sessionStorage.getItem(this.storageKey) ?? "masked"
  }
}
